module.exports = __webpack_public_path__ + "img/dog-human-meds-2.ed25d63a.jpg";